// Slow breathing fallback for when there's no BPM to pulse on - a fixed
// LFO period, independent of the caller's own decay (that's a per-beat
// shape, meaningless once there's no beat to shape). Amplitude is scaled
// down (x0.4) relative to the real on-beat pulse: a "no BPM" breathing
// motion should read as ambient, not compete with a genuine beat-locked
// visual for attention.
const NO_BPM_LFO_PERIOD_S = 2.4;
const NO_BPM_LFO_AMPLITUDE_SCALE = 0.4;

// Shared "flash right on the beat, decay before the next one" pulse
// multiplier - see scene-manager.js's _updateBeatPhase for where
// profile.beatPhase actually comes from (BPM via Deezer + an
// extrapolated playback position, null whenever there's no BPM to work
// with). Every caller multiplies this straight into whatever brightness/
// size uniform it already computes each frame.
//
// timeSeconds is optional and ONLY used when beatPhase is null: without it,
// a missing beatPhase returns exactly 1 (no-op), same as before director.js
// existed. With it (director.pulse() always passes scene-manager's own
// pause-aware clock - see director.js), a missing beatPhase instead
// returns a slow sinusoidal breathing motion - "un seul point de bascule
// pour tout le projet" per the brief, so every caller (migrated to
// director.pulse() or not) gets the same no-BPM behavior for free.
export function computeBeatPulse(beatPhase, amount, decay, timeSeconds) {
  if (beatPhase == null) {
    if (timeSeconds == null) return 1;
    return 1 + amount * NO_BPM_LFO_AMPLITUDE_SCALE * Math.sin((2 * Math.PI * timeSeconds) / NO_BPM_LFO_PERIOD_S);
  }
  return 1 + amount * Math.exp(-beatPhase * decay);
}
